import React from 'react';

import Chip from '@mui/material/Chip';

import { ApprovalStatus } from 'stores/TicketStoreAdapter';

const ApprovalStatusColor: Record<ApprovalStatus, string> = {
  ADJUSTING: '#757575',
  SUBMITTED: '#1976d2',
  IN_PROGRESS: '#ed6c02',
  APPROVED: '#2e7d32',
  REJECTED: '#d32f2f',
  CANCELLED: '#9e9e9e',
};

type Props = {
  status: ApprovalStatus;
  size?: 'small' | 'medium';
};

/** 承認ステータス（調整中/申請中/対応中/承認/否決/取消）を表示するチップ */
const ApprovalStatusChip: React.FC<Props> = ({ status, size = 'small' }) => {
  const color = ApprovalStatusColor[status];
  return (
    <Chip
      label={ApprovalStatus[status]}
      size={size}
      sx={{
        color: '#fff',
        backgroundColor: color,
        fontWeight: 400,
        ...(size === 'small' && { height: 20, fontSize: '0.7rem' }),
      }}
    />
  );
};

export default ApprovalStatusChip;
